var __TEMP__ = require('./_ListCache.js');var ListCache = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_Map.js');var Map = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_MapCache.js');var MapCache = __REQUIRE_DEFAULT__(__TEMP__);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = stackSet;
